import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  channelList: [],
};

const channelsSlice = createSlice({
  name: "channels",
  initialState,
  reducers: {
    setChannelsList: (state, action) => {
      state.channelList = action.payload;
    },
  },
});

export const { setChannelsList } = channelsSlice.actions;

export default channelsSlice.reducer;
